import { Box, BoxProps } from '@chakra-ui/react'
import React from 'react'
import { MessageThread } from '../types/chatTypes'
import { Answer } from './Answer/Answer'
import { AppliedCommandTags } from './AppliedCommandTags'
import { InputValidationError } from './InputValidationError'
import { UserChatMessage } from './UserChatMessage'

interface ChatBubbleProps extends BoxProps {
  thread: MessageThread
  onRetry: () => void
  onToggleResponseMinimized?: (responseMessageId: string) => void
  currentPhase?: {tempId: string, phase: 'internal_streaming' | 'llm_resumed'} | null
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ thread, onRetry, onToggleResponseMinimized, currentPhase, ...props }) => {

  return (
    <Box {...props}>
      {thread.question && (
        <UserChatMessage
          message={thread.question}
          attachedDocument={thread.attachedAsset}
        />
      )}

      <AppliedCommandTags commands={thread.appliedCommands} />

      {/* Show input validation error if present */}
      {thread.inputValidationError && (
        <Box mt={4}>
          <InputValidationError
            error={thread.inputValidationError}
            errorDetails={thread.inputValidationErrorDetails}
            onRetry={onRetry}
          />
        </Box>
      )}

      {thread.answers.sort((a, b) => a.knowledgeSource === 'LLM_ONLY' ? -1 : 1).map((answer, index) => (
        <Box key={answer.message_id} mt={index > 0 ? 4 : 0} data-dd-privacy='mask'>
          <Answer
            answer={answer}
            withFeedback={thread.question !== undefined}
            isLoading={answer.isStreaming && answer.answer === ''}
            onRetry={onRetry}
            onToggleMinimized={onToggleResponseMinimized ? () => onToggleResponseMinimized(answer.message_id) : undefined}
            hasMultipleAnswers={thread.answers.length > 1}
            scopeCommands={thread.appliedCommands}
          />
        </Box>
      ))}
    </Box>
  )
}

export default React.memo(ChatBubble)
